<template>
  <header>
    <nav class="navbar navbar-expand-lg navbar-light">
      <router-link class="navbar-brand link-logo" to="/">
        <img :src="partner.logo_url" class="partner-logo"/>
      </router-link>
      <SummaryCart class="cart-mobile-component" v-if="partner.sales"/>
      <a class="favorite-mobile" @click="myFavorites">
        <i class="fas fa-heart btn-favorites"></i>
      </a>
      <button class="navbar-toggler mobile_button_burger" type="button" data-bs-toggle="collapse"
              data-bs-target="#navbarContent" aria-controls="navbarContent"
              aria-expanded="false" aria-label="Toggle navigation">
        <span class="navbar-toggler-icon"></span>
      </button>
      <button class="navbar-toggler mobile_button_close" type="button"
              data-bs-toggle="collapse" style="display: none"
              data-bs-target="#navbarContent" aria-controls="navbarContent"
              aria-expanded="false" aria-label="Toggle navigation">
        <span class="navbar-toggler-icon-x"></span>
      </button>
      <div class="collapse navbar-collapse" id="navbarContent">
        <ul class="navbar-nav me-auto mb-2 mb-lg-0"></ul>
        <ul class="navbar-nav navbar-right mb-lg-0 app-navbar">
          <li class="nav-item">
            <router-link class="nav-link" aria-current="page" to="/events">
              {{ $t("menu.events") }}
            </router-link>
          </li>
          <li class="nav-item">
            <router-link class="nav-link" to="/contact">
              {{ $t("menu.contact") }}
            </router-link>
          </li>
          <li class="nav-item user-menu dropdown" v-if="user.signed()">
            <a id="dropdownMenu" class="nav-link" data-bs-toggle="dropdown" aria-expanded="false">
              <img :src="user.avatar_url" class="avatar"/>
              {{user.name}}
              <i class="fa fa-angle-down ml-5" aria-hidden="true"></i>
            </a>
            <ul class="dropdown-menu" aria-labelledby="dropdownMenu">
              <li>
                <router-link class="dropdown-item" :to="{name:'Profile'}">
                  {{$t("menu.profile")}}
                </router-link>
              </li>
              <li>
                <a v-if="user.role == 'sale'" href="/admin/orders" class="dropdown-item">
                  {{$t("menu.orders")}}
                </a>
              </li>
              <li v-if="user.is_admin">
                <a href="/administrator" class="dropdown-item">
                  {{$t("menu.admin")}}
                </a>
              </li>
              <li><hr class="dropdown-divider"></li>
              <li>
                <a rel="nofollow" href="/auth/users/sign_out" class="dropdown-item">
                  {{$t("menu.close")}}
                </a>
              </li>
            </ul>
          </li>
          <li class="nav-item" v-if="!user.signed()" v-show="loaded">
            <p class="btn-login" @click="signIn()">
              {{ $t("menu.login") }}
            </p>
          </li>
          <li class="nav-item relative-car" v-if="partner.sales" >
            <SummaryCart class="cart-pc-component"/>
          </li>
          <li class="nav-item favorite-pc">
            <a class="nav-link" @click="myFavorites">
              <i class="fas fa-heart btn-favorites" ></i>
            </a>
          </li>
          <li class="nav-item" v-if="multipleLanguage">
            <a class="nav-link" @click="setLocale($i18n.locale)">
              {{ $t(`languages.${$i18n.locale}`) }}
            </a>
          </li>
        </ul>
      </div>
    </nav>
    <SignIn/>
  </header>
</template>

<script>
import moment from 'moment';
import User from '../models/User';
import Partner from '../models/Partner';
import SignIn from '../views/auth/SignIn';
import { mapActions, mapGetters } from 'vuex';
import SummaryCart from './shopping_cart/SummaryCart';

export default {
  name: 'Navbar',
  components: {
    SignIn,
    SummaryCart
  },
  data() {
    return {
      partner: new Partner(),
      user: new User(),
      loaded: false,
      languages: []
    }
  },
  mounted() {
    this.$root.$on('setPartner', this.setPartner);
    this.user = this.currentUser;
    this.loaded = true;
  },
  methods: {
    ...mapActions('Preference', ['setPreference']),
    avaliableLanguage() {
      let lang = localStorage.getItem("language")

      const avaliable = this.languages.find(language => {
        return language.locale == lang
      })

      if(avaliable) {
        this.switchLanguage(lang)
      } else {
        lang = this.languages[0].locale
        this.setLocale(lang)
      }
    },
    setLanguages() {
      this.languages = this.partner.languages.map(language => {
        return {
          locale: language.code,
          text: this.$t(`languages.${language.code}`)
        }
      })
    },
    setLocale(locale) {
      let lang = (locale == "es-MX") ? "en" : "es-MX"

      if(this.singleLanguage) {
        lang = locale
      }

      if (this.$user.signed()) {
        this.setUserLanguage(lang)
      } else {
        this.updateLanguage(lang)
      }
    },
    setPartner(partner) {
      this.partner = partner
      this.setLanguages()
      this.avaliableLanguage()
      this.setPreference(partner)
    },
    setUser(user) {
      this.user = user
      this.setCurrentUser(user)
    },
    setUserLanguage(lang) {
      this.$user.setLanguage(lang).then(() => {
        this.updateLanguage(lang)
      }).catch((error) => {
      })
    },
    signIn() {
      this.$root.$emit('openSignIn')
    },
    updateLanguage(lang) {
      localStorage.setItem('language', lang)
      this.switchLanguage(lang)
    },
    switchLanguage(lang) {
      this.$i18n.locale = lang
      this.localValidator(lang)
      moment.locale(lang)
    },
    localValidator(lang) {
      import(`../locales/vee-validate-locales/${lang}`).then(locale => {
        this.$validator.localize(lang, locale)
      })
    },
    myFavorites() {
      if (this.user.signed()) {
        this.$router.replace({name: "MyFavorites"})
      } else {
        this.signIn()
      }
    },
  },
  computed: {
    ...mapGetters('Auth', ['currentUser']),

    totalLanguages() {
      return this.languages.length
    },
    singleLanguage() {
      return this.totalLanguages == 1
    },
    multipleLanguage() {
      return this.totalLanguages > 1
    }
  }
}
</script>

<style lang="scss" scoped>
  @import '../scss/variables.scss';

  .app-navbar {
    margin-right: 15px;
    margin-top: 10px
  }

  .dropdown-menu{
    min-width: 274px !important;
  }

  .app-navbar {
    margin-right: 15px;
    margin-top: 10px
  }

  .link-logo {
    margin-left: 40px;
  }

  .partner-logo {
    height: 40px;
  }

  .cart-mobile-component {
    display: none;
  }

  .navbar {
    background-color: $primary-base !important;

    .nav-link {
      color: $accent-base !important;
      font-family: $font-bold !important;
      cursor: pointer;
    }
  }

  ul.navbar-nav {
    li.nav-item {
      margin-left: 10px;
    }

    .user-menu {
      .avatar {
        width: 30px;
        height: 30px;
        border-radius: 50%;
        margin-right: 5px;
      }
    }
  }

  .favorite-mobile {
    display: none;
  }

  .btn-login {
    color: $secondary-base;
    padding: 5px 10px;
    border: 1px solid $secondary-base;
    border-radius: 40px;
    cursor: pointer;
    text-align: center;
  }

  .modal {
    position: fixed;
    top: 0;
    left: 0;
    z-index: 1060;
    display: block;
    width: 100%;
    height: 100%;
    overflow-x: hidden;
    overflow-y: auto;
    outline: 0;
    background: rgb(0, 0, 0, 0.3);
  }

  .product_discount {
    text-decoration: line-through;
    color: #c4c4c4;
    width: 80%;
  }

  .btn-favorites {
    font-size: 24px;
  }

  @media screen and (max-width: 768px) {
    .link-logo {
      margin-left: 5px !important;
    }
    .cart-mobile-component {
      display: block;
    }
    .favorite-mobile {
      display: block;
    }
    .cart-pc-component {
      display: none;
    }
    .favorite-pc {
      display: none;
    }
  }

  @media only screen and (max-width: 340px) and (min-width: 5px)  {
    .link-logo {
      margin-left: 5px !important;
      width: 144px !important;
    }
    .partner-logo{
      width: 100%;
    }
  }
  header{
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    z-index: 1000;
    background-color: white;
    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
  }
  .relative-car{
    position: relative;
  }
</style>
